/** @jsx jsx */

import React, { useState } from "react";
import { css, jsx } from "@emotion/react";
import { withPrefix } from "gatsby-link";
import { getVideoThumbnail } from "../../../ng-components/Video/Video";
import ntv from "../../../images/noissuetv.svg";
import { Video } from "../../../ng-components/Video/Video";

const TVBlock = ({ videos }) => {
    const [activeVideo, setVideo] = useState(videos[0]);
    return (
        <>
            <style jsx>
                {`
                    .indus {
                        color: #fc566f;
                    }

                    .item {
                        margin-right: 2.5rem;
                    }
                    .item :first-of-type {
                        margin-left: 10rem;
                    }
                    .rose {
                        display: block;
                        color: #fc566f;
                        margin: 1rem 0;
                        font-weight: 400;
                    }

                    .date {
                        font-size: 1.3rem;
                        color: #c8c8c8;
                        display: block;
                    }

                    .tags {
                        width: 100%;
                    }
                    .tag-link {
                        border-radius: 2rem;
                        border: unset;
                        margin: 1rem 0;
                        color: #979797;
                        background: #ededed;
                        font-size: 1rem;
                        line-height: 2.7em;
                        height: 2.4rem;
                        padding: 0 0.9rem;
                        font-family: Soleil, -apple-system, BlinkMacSystemFont,
                            Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell,
                            Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
                        letter-spacing: 0;
                        text-align: center;
                        display: inline-block;
                    }

                    .header {
                        justify-content: space-between;
                        display: flex;
                        flex-wrap: wrap;
                        width: 100%;
                        text-align: start;
                    }

                    .title {
                        font-family: Soleil;
                        font-size: 1.8rem;
                        line-height: normal;
                        color: #393972;
                    }
                    .desc {
                        font-size: 1.4rem;
                        color: #616161;
                        line-height: normal;
                        font-weight: 300;
                    }
                    .author {
                        margin-top: 1.9rem;
                        margin-right: 1rem;
                        position: relative;
                    }
                    .a-img {
                        width: 6.1rem;
                        height: 6.1rem;
                        display: block;
                        border-radius: 100%;
                        border: 0.1rem solid #eee;
                        background-size: cover;
                    }
                    .a-name {
                        font-size: 1.5rem;
                        font-weight: bold;
                        color: #393972;
                        letter-spacing: 0;
                        margin-top: 2.3rem;
                        display: block;
                    }
                    .col {
                        flex: 1;
                    }
                    .active & .title {
                        color: #fff;
                    }
                    .active & .desc {
                        color: #D9D9E3;
                    }
                    .active {
                        background-color: #393972;
                    }
                    .active & .tag-link {
                        color: #fff;
                        background: rgb(255 255 255 / 30%);
                    }
                    .bg-white {
                        background-color: #fff;
                    }
                `}
            </style>
            <div
                css={css`
                    position: relative;
                    height: 40rem;
                    max-width: 90rem;
                    border: 0.8rem solid #393972;
                    background-color: #393972; 
                    margin: 5rem auto 2rem auto;
                    border-radius: 1rem;
                    @media (max-width: 1024px) {
                        max-width: 76rem;
                    }
                    @media (max-width: 768px) {
                        width: 95%;
                        flex-direction: column;
                        height: 80rem;
                        margin-bottom: 0rem;
                    }
                    display: flex;
                `}
            >
                <div css={css`
                    background-color: #393972;
                    padding: .5rem;
                    border-radius: 50%;
                    position: absolute;
                    top: -5rem;
                    left: 2rem;
                    z-index: 1;
                    `}>
                    <div css={css`
                        background-image: url(${ntv});
                        display: block;
                        position: relative;
                        height: 8rem;
                        width: 8rem;
                        background-repeat: no-repeat;
                        background-size: contain;
                    `}/>
                </div>
                <div
                    css={css`
                        width: 60%;
                        background-color: #000;
                        @media (max-width: 768px) {
                            width: 100%;
                            height: auto;
                            margin: auto;
                        }
                    `}
                >
                    <Video className="p-video" url={activeVideo.url} />

                    {/* <a css={css`
                            position: absolute;
                            left: 2rem;
                            bottom: 2rem;
                            cursor: pointer;
                            width: 4rem;
                            height: 4rem;
                            border-radius: 50%;
                            background-color: #393972;
                        `}
                            href={withPrefix(`/${activeVideo.slug}`)}
                        >
                        <div
                        css={css`            
                            width: 0; 
                            height: 0; 
                            border-top: 1rem solid transparent;
                            border-bottom: 1rem solid transparent;                            
                            border-left: 1.5rem solid #fff;
                            display: inline-block;
                            margin-top: .9rem;
                            margin-left: .6rem;
                          `}
                        />                

                    </a> */}
                </div>
                <div
                    css={css`
                        width: 40%;
                        display: block;
                        overflow: auto;
                        ::-webkit-scrollbar {
                            width: 0rem;
                            height: 1rem;
                            background-color: transparent;
                            border-radius: 0.5rem;
                        }
                        ::-webkit-scrollbar-thumb {
                            box-shadow: inset 0 0 6px transparent;
                            border-radius: 10px;
                            background-color: transparent;
                        }
                        @media (max-width: 768px) {
                            width: 100%;
                            height: 40rem;
                        }
                    `}
                >
                    {videos?.map((video) => (
                        <div 
                            className={video.id === activeVideo.id? 'active' : 'bg-white'}
                            onClick={()=> setVideo(video)}
                            css={css`
                                padding: 2rem;
                                cursor: pointer;
                            `}
                        >
                            <div className="header">
                                <div className="tags">
                                <a
                                    className="tag-link"
                                    href={withPrefix(`${video.channel.slug}`)}
                                >
                                    {video.channel.name}
                                </a>
                                </div>
                                <h2 className="title">{video.title}</h2>
                                <p className="desc">{video.excerpt.excerpt}</p>

                                <div className="col">
                                    <span className="date">
                                        {video.display_created_at}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default TVBlock;
